var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("upload-settings")))]),
      _c(
        "w-card-content",
        [
          _vm.value
            ? _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _vm._v(" " + _vm._s(_vm.fileName) + " "),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "app-file-upload",
                    {
                      attrs: { "allowed-extensions": ["json", "txt"] },
                      on: {
                        input: function ($event) {
                          return _vm.onFile($event)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("json-file-here")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "save", disabled: !_vm.value },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }